import React from 'react';
import { ChevronRightIcon, HelpCircleIcon } from 'lucide-react';
import { problems, solutionSteps } from '../data/content';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function Pain() {
  return <section className="bg-white px-4 py-14 md:py-20" data-id="element-190" data-mp="1j0oc9hnx94hv">
      <div className="mx-auto max-w-5xl" data-id="element-191" data-mp="1e2mvx4hvrja3">
        <Eyebrow data-id="element-192" data-mp="1e1lcabmstogr">The reality</Eyebrow>
        <SectionTitle data-id="element-193" data-mp="1e4pnvu2lfmhg">
          Do you teach stretching but still have to figure out{' '}
          <Mark data-id="element-194" data-mp="1a34c6c1spe8u">what to do before every class?</Mark>
        </SectionTitle>
        <p className="mx-auto mt-5 max-w-2xl text-center text-base leading-relaxed text-charcoal/75 md:text-lg" data-id="element-195" data-mp="159jd0gogue82">
          Knowing exercises is not the same as having a complete progression. Every week you still
          have to decide:
        </p>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-196" data-mp="qd0vkdpruy0i">
          {problems.map(problem => <li key={problem} className="flex items-start gap-3 rounded-xl border border-charcoal/10 bg-ivory p-4" data-id="element-197" data-mp="mbfhip1i4doq">
              <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-forest" aria-hidden="true" data-id="element-198" data-mp="1yvou05xk84l9" />
              <span className="text-sm font-semibold text-charcoal md:text-base" data-id="element-199" data-mp="23pkkknbhup6e">{problem}</span>
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl bg-forest p-7 text-center md:p-10" data-id="element-200" data-mp="1ty6hy6o8x991">
          <p className="font-display text-xl font-black uppercase leading-tight text-ivory md:text-3xl" data-id="element-201" data-mp="1tw3u9takfs7h">
            You don't need another random routine.
          </p>
          <p className="mt-2 font-display text-xl font-black uppercase leading-tight text-gold md:text-3xl" data-id="element-202" data-mp="2mlj5ok657n3x">
            You need a system that connects one class to the next.
          </p>
          <ol className="mt-7 flex flex-wrap items-center justify-center gap-2" data-id="element-203" data-mp="2cnmqnha3480j">
            {solutionSteps.map((step, index) => <li key={step} className="flex items-center gap-2" data-id="element-204" data-mp="xa0gfsmmewyz" data-mpi={index}>
                {index > 0 && <ChevronRightIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-205" data-mp="11b2ggbod3d20" />}
                <span className="rounded-lg bg-ivory px-3 py-2 text-sm font-extrabold text-forest" data-id="element-206" data-mp="33uv3s1eqmdli">
                  {step}
                </span>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}